import { ItemZoneContext } from '@context/ItemZoneContext'
import { useAppStore } from '@store'
import { forwardRef, useContext, useEffect, useRef, useState } from 'react'
import { BoxButtonsEditorWrapper } from '../BoxButtonsEditorWrapper'
import { GroupSearch } from '../GroupSearch'
import { EditorWrapper } from './EditorWrapper'
import { ObjectZonesEditor } from './ObjectZonesEditor'
import { TextureGroupEditor } from './TextureGroupEditor'
import { TexturesEditor } from './TexturesEditor'

type Props = {
  showOnDemand?: boolean
  closeFn?: () => void
}

const ItemEditor = forwardRef<HTMLDivElement, Props>(function ItemEditor(
  { showOnDemand = true, closeFn = () => {} }: Props,
  ref,
) {
  const { setCurrentTexture, currentTexture } = useContext(ItemZoneContext)
  const closeModal = useAppStore.use.closeModal()
  const id = useAppStore((s) => s.currentObjectID)
  const selected = useAppStore(
    (s) => s.items.get(s.currentObjectID) ?? s.areas.get(s.currentObjectID),
  )

  const [isVisible, setIsVisible] = useState(showOnDemand)

  useEffect(() => {
    setIsVisible(showOnDemand)
  }, [showOnDemand])

  const closeItemEditor = () => {
    setIsVisible(false)
    closeFn()
    closeModal()
    setCurrentTexture('')
  }

  const itemEditorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e?.key === 'Escape' || e?.key === 'Esc' || e?.keyCode === 27) {
        e?.nativeEvent?.preventDefault()
        e?.nativeEvent?.stopPropagation()
        closeItemEditor()
      }
    }

    document.addEventListener('keydown', handleKeyPress)
    return () => document.removeEventListener('keydown', handleKeyPress)
  }, [])

  if (!isVisible) {
    return null
  }

  return (
    <div
      ref={ref || itemEditorRef}
      id='cccc'
    >
      <EditorWrapper closeFn={closeItemEditor}>
        <div className='flex h-[690px] w-[640px] overflow-hidden'>
          <section className='flex flex-1 flex-col overflow-hidden'>
            <ObjectZonesEditor />
            <BoxButtonsEditorWrapper />
          </section>
          <section className='flex flex-1 flex-col overflow-hidden'>
            <TextureGroupEditor key={selected?.id} />
            <GroupSearch />
          </section>
        </div>
        <TexturesEditor closeFn={closeItemEditor} />
      </EditorWrapper>
    </div>
  )
})
export default ItemEditor
